export default "__VITE_ASSET__DwxDD5tL__"